<template>
  <div class="about-us">
    <!-- Header -->
    <vue-headful
      v-if="meta"
      :title="meta.fields['Title']"
      :description="meta.fields['Description']"
      :keywords="meta.fields['Keywords']" />
    <!-- End Header -->

    <!-- Loader -->
    <vue-element-loading
      :active="!allLoaded"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- About Us -->
    <v-container style="max-width: 1000px;">
      <v-responsive max-width="800px">
        <section v-if="allLoaded"
                 id="about">
          <h1 :class="`${$vuetify.breakpoint.lgAndUp ?' display-3': 'headline'} font-weight-black my-5 mx-3`">
            We Are A Development Driven Digital Agency
          </h1>
          <template v-if="header">
            <video-player ref="videoPlayer"
                          class="video-player-box my-5 py-5"
                          :options="playerOptions(header.fields.Attachments[0].url, header.fields.Attachments[1].url)"
                          :playsinline="true" />
          </template>
        </section>
        <section v-for="aboutUs in aboutUsCollection"
                 :id="aboutUs.id"
                 :key="aboutUs.id">
          <h1 class="display-1 font-weight-black my-5">
            {{ aboutUs.fields.Name }}
          </h1>
          <div class="my-5"
               v-html="aboutUs.fields['Body Text']" />
        </section>
      </v-responsive>
    </v-container>
    <!-- End About Us -->

    <!-- Clientele -->
    <section v-if="allLoaded"
             id="clientele">
      <v-container fluid
                   class="lighten-2 py-5 mb-5">
        <v-row v-for="_clients in clients"
               :key="_clients.id"
               justify="space-between">
          <v-col />
          <v-col v-for="client in _clients"
                 :key="client.id"
                 cols="2"
                 align-self="center"
                 align="center">
            <v-img v-if="(client.fields.Attachments)"
                   :eager="true"
                   :src="client.fields.Attachments[0].url"
                   aspect-ratio="1.7778"
                   contain
                   max-width="100" />
          </v-col>
          <v-col />
        </v-row>
      </v-container>
    </section>
    <!-- End Clientele -->

    <!-- Case Studies -->
    <section v-if="allLoaded"
             id="clientele">
      <v-container fluid
                   class="grey lighten-2 py-5">
        <v-col align="center"
               justify="center">
          <h2 class="display-1 font-weight-black">
            We Work With
          </h2>
          <v-row align="center"
                 justify="center">
            <span v-for="(_caseStudyTitle) in caseStudiesTitles"
                  :key="_caseStudyTitle.id"
                  align="center"
                  justify="center"
                  class="display-1 font-weight-regular">
              <router-link v-if="_caseStudyTitle.fields.Order > 2"
                           :to="{ name: 'work', params: { slug: _caseStudyTitle.fields.Slug } }">
                {{ _caseStudyTitle.fields.Name }}
              </router-link>
              <span v-if="(caseStudiesTitles.length !== _caseStudyTitle.fields.Order) && _caseStudyTitle.fields.Order > 2">&#44;</span>
            </span>
            <span class="display-1 font-weight-regular">&#46;</span>
          </v-row>
        </v-col>
      </v-container>
    </section>
    <!-- End Case Studies -->
  </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
import _ from "lodash";
import qs from "qs";

export default {
	name: "About",

	components: {
		videoPlayer,
		VueElementLoading
	},

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,

			isGetAboutUsLoading: false,
			isGetClientsLoading: false,
			isGetCaseStudiesTitlesLoading: false,

			header: null,
			videoUrl: '',
			aboutUsCollection: [],
			caseStudiesTitles: [],
			clients: null,
		};
	},

	mounted: function() {
		this.isGetAboutUsLoading,  this.isGetClientsLoading , this.isGetCaseStudiesTitlesLoading= true;
		this.getAboutUs();
		this.getClients();
		this.getCaseStudiesTitles();
	},

	computed: {
		meta: function () {
			return this.$store.getters['meta/getMeta'](this.$route.path);
		},

		allLoaded: function () {
			if (!this.isGetAboutUsLoading && !this.isGetClientsLoading && !this.isGetCaseStudiesTitlesLoading) {
				return true;
			}
			return false;
		},
	},

	methods: {

		playerOptions: function(videoUrl, posterUrl) {
			return {
				loop: true,
				fluid: true,
				autoplay: true,
				muted: true,
				language: 'en',
				playbackRates: [ 0.7, 1.0, 1.5, 2.0 ],
				sources: [ {
					type: "video/mp4",
					src: videoUrl,
				} ],
				poster: posterUrl,
			};
		},

		getAboutUs: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/AboutUs",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				}
			}).then(res => {
				let r = res.data.records;
				let self = this;
				_.forEach(r, function(o) {
					if (o.fields.Name === "Header") {
						self.header = o;
					} else {
						self.aboutUsCollection.push(o);
					}
				});
			}).finally(() => {
				this.isGetAboutUsLoading = false;
			});
		},

		getClients: function() {
			let numColumns = 4;
			axios({
				url: this.apiUrl + this.apiBase + "/Clients",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Sorting", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.clients = _.chunk(res.data.records, numColumns);
			}).finally(() => {
				this.isGetClientsLoading = false;
			});
		},

		getCaseStudiesTitles: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/HomeWeBuildThemFor",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Order", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.caseStudiesTitles = res.data.records;
				this.caseStudiesTitles.forEach(el => el.fields.Name.trim());
			}).finally(() => {
				this.isGetCaseStudiesTitlesLoading = false;
			});
		},
	}
};
</script>
